// import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import axios from 'axios';
// import {
//   Container,
//   Card,
//   Table,
//   Button,
//   Alert,
//   Spinner
// } from 'react-bootstrap';
// import { BsEye } from 'react-icons/bs';

// export default function ServitorOrderHistory() {
//   const navigate = useNavigate();
//   const [servitors, setServitors] = useState([]);
//   const [error, setError] = useState('');
//   const [loadingServitors, setLoadingServitors] = useState(false);

//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchServitors = async () => {
//       setLoadingServitors(true);
//       try {
//         const { data } = await axios.get(
//           'http://localhost:4001/admin/servitors/metrics',
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         setServitors(data);
//       } catch (err) {
//         setError('Failed to load servitors.');
//       } finally {
//         setLoadingServitors(false);
//       }
//     };
//     fetchServitors();
//   }, [token]);

//   return (
//     <Container className="py-4">
//       <h2 className="mb-4">Servitor Order History</h2>
//       {error && <Alert variant="danger">{error}</Alert>}

//       <Card className="shadow-sm">
//         <Card.Header>Servitors</Card.Header>
//         <Card.Body>
//           {loadingServitors ? (
//             <div className="text-center">
//               <Spinner animation="border" />
//             </div>
//           ) : (
//             <Table hover responsive>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Name</th>
//                   <th>Servitor ID</th>
//                   <th>Service</th>
//                   <th>Mobile</th>
//                   <th>Total Orders</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {servitors.map((s, i) => {
//                   const totalOrders = 
//                     (s.ordersAccepted || 0) +
//                     (s.ordersCompleted || 0) +
//                     (s.ordersCancelledByServitor || 0);

//                   return (
//                     <tr key={s.id}>
//                       <td>{i + 1}</td>
//                       <td>{s.name}</td>
//                       <td>{s.id}</td>
//                       <td>{s.service}</td>
//                       <td>{s.mobile}</td>
//                       <td>{totalOrders}</td>
//                       <td>
//                         <Button
//                           size="sm"
//                           variant="outline-primary"
//                           onClick={() => navigate(
//                             `/admin/servitororderhistory/${s.id}`
//                           )}
//                         >
//                           <BsEye /> View History
//                         </Button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </Table>
//           )}
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }













// import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import axios from 'axios';
// import {
//   Container,
//   Card,
//   Table,
//   Button,
//   Alert,
//   Spinner,
//   InputGroup,
//   Form,
//   Row,
//   Col,
//   Pagination,
// } from 'react-bootstrap';
// import { BsEye } from 'react-icons/bs';
// import './ServitorOrderHistory.css';
// import { URL } from '../../../config';

// export default function ServitorOrderHistory() {
//   const navigate = useNavigate();
//   const [servitors, setServitors] = useState([]);
//   const [filteredServitors, setFilteredServitors] = useState([]);
//   const [error, setError] = useState('');
//   const [loadingServitors, setLoadingServitors] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterService, setFilterService] = useState('All');
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchServitors = async () => {
//       setLoadingServitors(true);
//       try {
//         const { data } = await axios.get(
//           `${URL}/admin/servitors/metrics`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         setServitors(data);
//         setFilteredServitors(data);
//         setError('');
//       } catch (err) {
//         setError('Failed to load servitors. Please try again later.');
//       } finally {
//         setLoadingServitors(false);
//       }
//     };
//     fetchServitors();
//   }, [token]);

//   useEffect(() => {
//     let results = servitors;
//     if (searchTerm) {
//       results = results.filter(
//         (servitor) =>
//           servitor.id?.toString().includes(searchTerm) ||
//           servitor.mobile?.toString().includes(searchTerm) ||
//           servitor.name?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
//     if (filterService !== 'All') {
//       results = results.filter((servitor) => servitor.service === filterService);
//     }
//     setFilteredServitors(results);
//     setCurrentPage(1);
//   }, [searchTerm, filterService, servitors]);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredServitors.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredServitors.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) {
//       end = Math.min(total - 1, maxButtons - 1);
//     }
//     if (current >= total - (siblings + 1)) {
//       start = Math.max(2, total - (maxButtons - 2));
//     }

//     if (start > 2) {
//       pages.push('start-ellipsis');
//     }

//     for (let i = start; i <= end; i++) {
//       pages.push(i);
//     }

//     if (end < total - 1) {
//       pages.push('end-ellipsis');
//     }

//     if (total > 1) {
//       pages.push(total);
//     }

//     return pages;
//   };

//   return (
//     <Container fluid className="servitororderhistory-container">
//       <Card className="servitororderhistory-card">
//         <Card.Body>
//           {/* <Card.Title className="servitororderhistory-title">
//             Servitor Order History
//           </Card.Title> */}

//           <Card.Header className="servitororderhistory-header">
//             <h4 className="servitororderhistory-title">
//               Servitor Order History
//             </h4>
//           </Card.Header>

//           {error && (
//             <Alert variant="danger" className="servitororderhistory-error">
//               {error}
//             </Alert>
//           )}

//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Servitor ID, Name, or Mobile"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="servitororderhistory-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="serviceFilter">
//                 <Form.Select
//                   value={filterService}
//                   onChange={(e) => setFilterService(e.target.value)}
//                   className="servitororderhistory-filter-select"
//                 >
//                   <option value="All">All Services</option>
//                   <option value="Electrician">Electrician</option>
//                   <option value="Home Cleaning">Home Cleaning</option>
//                   <option value="Plumber">Plumber</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="servitororderhistory-filter-container">
//             <div className="servitororderhistory-service-filters">
//               {["All", "Electrician", "Home Cleaning", "Plumber"].map(
//                 (service) => (
//                   <Button
//                     key={service}
//                     variant={
//                       filterService === service ? "primary" : "outline-primary"
//                     }
//                     className="servitororderhistory-filter-btn"
//                     onClick={() => setFilterService(service)}
//                   >
//                     {service}
//                   </Button>
//                 )
//               )}
//             </div>
//           </div>

//           {loadingServitors ? (
//             <div className="text-center">
//               <Spinner animation="border" />
//             </div>
//           ) : (
//             <Table
//               striped
//               bordered
//               hover
//               responsive
//               className="servitororderhistory-table"
//             >
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Servitor ID</th>
//                   <th>Name</th>
//                   <th>Service</th>
//                   <th>Mobile</th>
//                   <th>Total Orders</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map((servitor, index) => {
//                   const totalOrders =
//                     (servitor.ordersAccepted || 0) +
//                     (servitor.ordersCompleted || 0) +
//                     (servitor.ordersCancelledByUser || 0) +
//                     (servitor.ordersDeadlineTimeout || 0) +
//                     (servitor.ordersCancelledByServitor || 0);

//                   return (
//                     <tr key={servitor.id}>
//                       <td>{index + 1 + indexOfFirstItem}</td>
//                       <td>{servitor.id}</td>
//                       <td>{servitor.name}</td>
//                       <td>{servitor.service}</td>
//                       <td>{servitor.mobile}</td>
//                       <td>{totalOrders}</td>
//                       <td>
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="servitororderhistory-action-btn"
//                           onClick={() =>
//                             navigate(
//                               `/admin/servitororderhistory/${servitor.id}`
//                             )
//                           }
//                         >
//                           <BsEye size={16} />
//                         </Button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </Table>
//           )}

//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//             />
//             {getPageItems(totalPages, currentPage).map((item, idx) => {
//               if (item === "start-ellipsis" || item === "end-ellipsis") {
//                 return <Pagination.Ellipsis key={item + idx} disabled />;
//               }
//               return (
//                 <Pagination.Item
//                   key={item}
//                   active={item === currentPage}
//                   onClick={() => handlePageChange(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               );
//             })}
//             <Pagination.Next
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage === totalPages}
//             />
//           </Pagination>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }









// ***** Updated with paginations (19-Oct-2025) ***** //
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import axios from 'axios';
// import {
//   Container,
//   Card,
//   Table,
//   Button,
//   Alert,
//   Spinner,
//   InputGroup,
//   Form,
//   Row,
//   Col,
//   Pagination,
// } from 'react-bootstrap';
// import { BsEye } from 'react-icons/bs';
// import './ServitorOrderHistory.css';
// import { URL } from '../../../config';

// const DEFAULT_LIMIT = 10;

// export default function ServitorOrderHistory() {
//   const navigate = useNavigate();

//   const [rows, setRows] = useState([]);
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   // filters
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterService, setFilterService] = useState('All');

//   // pagination (server meta)
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: DEFAULT_LIMIT,
//     total: 0,
//     totalPages: 1,
//     search: '',
//     serviceType: 'All',
//     sortBy: 'id',
//     sortDir: 'ASC',
//   });

//   const token = localStorage.getItem('adminToken');

//   const fetchPage = async () => {
//     setLoading(true);
//     try {
//       const { data } = await axios.get(
//         `${URL}/admin/servitors/metrics`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           params: {
//             page: meta.page,
//             limit: DEFAULT_LIMIT,
//             search: searchTerm,
//             serviceType: filterService === 'All' ? '' : filterService,
//             sortBy: 'id',
//             sortDir: 'ASC',
//           }
//         }
//       );
//       setRows(Array.isArray(data?.data) ? data.data : []);
//       if (data?.meta) setMeta((m) => ({ ...m, ...data.meta }));
//       setError('');
//     } catch (err) {
//       setError('Failed to load servitors. Please try again later.');
//       setRows([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPage();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [meta.page, searchTerm, filterService]);

//   const handlePageChange = (pageNumber) => {
//     setMeta((m) => ({ ...m, page: pageNumber }));
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));

//     if (start > 2) pages.push('start-ellipsis');
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push('end-ellipsis');
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   return (
//     <Container fluid className="servitororderhistory-container">
//       <Card className="servitororderhistory-card">
//         <Card.Body>
//           <Card.Header className="servitororderhistory-header">
//             <h4 className="servitororderhistory-title">Servitor Order History</h4>
//           </Card.Header>

//           {error && (
//             <Alert variant="danger" className="servitororderhistory-error">
//               {error}
//             </Alert>
//           )}

//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Servitor ID, Name, or Mobile"
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setMeta((m) => ({ ...m, page: 1 }));
//                   }}
//                   className="servitororderhistory-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="serviceFilter">
//                 <Form.Select
//                   value={filterService}
//                   onChange={(e) => {
//                     setFilterService(e.target.value);
//                     setMeta((m) => ({ ...m, page: 1 }));
//                   }}
//                   className="servitororderhistory-filter-select"
//                 >
//                   <option value="All">All Services</option>
//                   <option value="Electrician">Electrician</option>
//                   <option value="Home Cleaning">Home Cleaning</option>
//                   <option value="Plumber">Plumber</option>
//                   <option value="Gas Chula">Gas Chula</option>
//                   <option value="AC Service">AC Service</option>
//                   <option value="Filter">Filter</option>
//                   <option value="Tutor Service">Tutor Service</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="servitororderhistory-filter-container">
//             <div className="servitororderhistory-service-filters">
//               {["All", "Electrician", "Home Cleaning", "Plumber", "Gas Chula", "AC Service", "Filter", "Tutor Service"].map(
//                 (service) => (
//                   <Button
//                     key={service}
//                     variant={filterService === service ? "primary" : "outline-primary"}
//                     className="servitororderhistory-filter-btn"
//                     onClick={() => {
//                       setFilterService(service);
//                       setMeta((m) => ({ ...m, page: 1 }));
//                     }}
//                   >
//                     {service}
//                   </Button>
//                 )
//               )}
//             </div>
//           </div>

//           {loading ? (
//             <div className="text-center"><Spinner animation="border" /></div>
//           ) : (
//             <Table striped bordered hover responsive className="servitororderhistory-table">
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Servitor ID</th>
//                   <th>Name</th>
//                   <th>Service</th>
//                   <th>Mobile</th>
//                   <th>Total Orders</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.map((servitor, index) => {
//                   const totalOrders =
//                     (servitor.ordersAccepted || 0) +
//                     (servitor.ordersCompleted || 0) +
//                     (servitor.ordersCancelledByUser || 0) +
//                     (servitor.ordersDeadlineTimeout || 0) +
//                     (servitor.ordersCancelledByServitor || 0);

//                   return (
//                     <tr key={servitor.id}>
//                       <td>{index + 1 + (meta.page - 1) * meta.limit}</td>
//                       <td>{servitor.id}</td>
//                       <td>{servitor.name}</td>
//                       <td>{servitor.service}</td>
//                       <td>{servitor.mobile}</td>
//                       <td>{totalOrders}</td>
//                       <td>
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="servitororderhistory-action-btn"
//                           onClick={() => navigate(`/admin/servitororderhistory/${servitor.id}`)}
//                         >
//                           <BsEye size={16} />
//                         </Button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//                 {rows.length === 0 && (
//                   <tr><td colSpan={7} className="text-center">No servitors found.</td></tr>
//                 )}
//               </tbody>
//             </Table>
//           )}

//           <Pagination>
//             <Pagination.First onClick={() => handlePageChange(1)} disabled={meta.page === 1} />
//             <Pagination.Prev onClick={() => handlePageChange(meta.page - 1)} disabled={meta.page === 1} />
//             {getPageItems(meta.totalPages, meta.page).map((item, idx) => {
//               if (item === 'start-ellipsis' || item === 'end-ellipsis') {
//                 return <Pagination.Ellipsis key={item + idx} disabled />;
//               }
//               return (
//                 <Pagination.Item
//                   key={item}
//                   active={item === meta.page}
//                   onClick={() => handlePageChange(item)}
//                 >
//                   {item}
//                 </Pagination.Item>
//               );
//             })}
//             <Pagination.Next onClick={() => handlePageChange(meta.page + 1)} disabled={meta.page === meta.totalPages} />
//             <Pagination.Last onClick={() => handlePageChange(meta.totalPages)} disabled={meta.page === meta.totalPages} />
//           </Pagination>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }




// ***** Upper code is okay, updated with Auth protect (2-Dec-2025) ***** //
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Card,
  Table,
  Button,
  Alert,
  Spinner,
  InputGroup,
  Form,
  Row,
  Col,
  Pagination,
} from "react-bootstrap";
import { BsEye } from "react-icons/bs";
import "./ServitorOrderHistory.css";
import { URL } from "../../../config";

const DEFAULT_LIMIT = 10;

/* ========== Admin Auth Helper ========== */
const getAdminHeaders = () => {
  const adminToken = localStorage.getItem("adminToken");
  return adminToken ? { Authorization: `Bearer ${adminToken}` } : {};
};

export default function ServitorOrderHistory() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // filters
  const [searchTerm, setSearchTerm] = useState("");
  const [filterService, setFilterService] = useState("All");

  // pagination (server meta)
  const [meta, setMeta] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    total: 0,
    totalPages: 1,
    search: "",
    serviceType: "All",
    sortBy: "id",
    sortDir: "ASC",
  });

  const fetchPage = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${URL}/admin/servitors/metrics`, {
        headers: getAdminHeaders(),
        params: {
          page: meta.page,
          limit: DEFAULT_LIMIT,
          search: searchTerm,
          serviceType: filterService === "All" ? "" : filterService,
          sortBy: "id",
          sortDir: "ASC",
        },
      });

      const list = Array.isArray(data?.data) ? data.data : [];
      setRows(list);

      if (data?.meta) {
        setMeta((m) => ({
          ...m,
          ...data.meta,
        }));
      } else {
        setMeta((m) => ({
          ...m,
          total: list.length,
          totalPages: 1,
        }));
      }

      setError("");
    } catch (err) {
      console.error("Failed to load servitors:", err);
      setError("Failed to load servitors. Please try again later.");
      setRows([]);
      setMeta((m) => ({
        ...m,
        total: 0,
        totalPages: 1,
      }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meta.page, searchTerm, filterService]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > meta.totalPages) return;
    setMeta((m) => ({ ...m, page: pageNumber }));
  };

  const getPageItems = (total, current, maxButtons = 7) => {
    if (!total || total < 1) return [1];
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end = Math.min(total - 1, current + siblings);

    if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1))
      start = Math.max(2, total - (maxButtons - 2));

    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  return (
    <Container fluid className="servitororderhistory-container">
      <Card className="servitororderhistory-card">
        <Card.Body>
          <Card.Header className="servitororderhistory-header">
            <h4 className="servitororderhistory-title">Servitor Order History</h4>
          </Card.Header>

          {error && (
            <Alert variant="danger" className="servitororderhistory-error">
              {error}
            </Alert>
          )}

          <Row className="mb-3">
            <Col md={8}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by Servitor ID, Name, or Mobile"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setMeta((m) => ({ ...m, page: 1 }));
                  }}
                  className="servitororderhistory-search"
                />
              </InputGroup>
            </Col>
            <Col md={4}>
              <Form.Group controlId="serviceFilter">
                <Form.Select
                  value={filterService}
                  onChange={(e) => {
                    setFilterService(e.target.value);
                    setMeta((m) => ({ ...m, page: 1 }));
                  }}
                  className="servitororderhistory-filter-select"
                >
                  <option value="All">All Services</option>
                  <option value="Electrician">Electrician</option>
                  <option value="Home Cleaning">Home Cleaning</option>
                  <option value="Plumber">Plumber</option>
                  <option value="Gas Chula">Gas Chula</option>
                  <option value="AC Service">AC Service</option>
                  <option value="Filter">Filter</option>
                  <option value="Tutor Service">Tutor Service</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <div className="servitororderhistory-filter-container">
            <div className="servitororderhistory-service-filters">
              {[
                "All",
                "Electrician",
                "Home Cleaning",
                "Plumber",
                "Gas Chula",
                "AC Service",
                "Filter",
                "Tutor Service",
              ].map((service) => (
                <Button
                  key={service}
                  variant={filterService === service ? "primary" : "outline-primary"}
                  className="servitororderhistory-filter-btn"
                  onClick={() => {
                    setFilterService(service);
                    setMeta((m) => ({ ...m, page: 1 }));
                  }}
                >
                  {service}
                </Button>
              ))}
            </div>
          </div>

          {loading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : (
            <Table
              striped
              bordered
              hover
              responsive
              className="servitororderhistory-table"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Servitor ID</th>
                  <th>Name</th>
                  <th>Service</th>
                  <th>Mobile</th>
                  <th>Total Orders</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((servitor, index) => {
                  const totalOrders =
                    (servitor.ordersAccepted || 0) +
                    (servitor.ordersCompleted || 0) +
                    (servitor.ordersCancelledByUser || 0) +
                    (servitor.ordersDeadlineTimeout || 0) +
                    (servitor.ordersCancelledByServitor || 0);

                  return (
                    <tr key={servitor.id}>
                      <td>{index + 1 + (meta.page - 1) * meta.limit}</td>
                      <td>{servitor.id}</td>
                      <td>{servitor.name}</td>
                      <td>{servitor.service}</td>
                      <td>{servitor.mobile}</td>
                      <td>{totalOrders}</td>
                      <td>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="servitororderhistory-action-btn"
                          onClick={() =>
                            navigate(`/admin/servitororderhistory/${servitor.id}`)
                          }
                        >
                          <BsEye size={16} />
                        </Button>
                      </td>
                    </tr>
                  );
                })}
                {rows.length === 0 && (
                  <tr>
                    <td colSpan={7} className="text-center">
                      No servitors found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}

          <Pagination>
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={meta.page === 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(meta.page - 1)}
              disabled={meta.page === 1}
            />
            {getPageItems(meta.totalPages, meta.page).map((item, idx) => {
              if (item === "start-ellipsis" || item === "end-ellipsis") {
                return <Pagination.Ellipsis key={item + idx} disabled />;
              }
              return (
                <Pagination.Item
                  key={item}
                  active={item === meta.page}
                  onClick={() => handlePageChange(item)}
                >
                  {item}
                </Pagination.Item>
              );
            })}
            <Pagination.Next
              onClick={() => handlePageChange(meta.page + 1)}
              disabled={meta.page === meta.totalPages}
            />
            <Pagination.Last
              onClick={() => handlePageChange(meta.totalPages)}
              disabled={meta.page === meta.totalPages}
            />
          </Pagination>
        </Card.Body>
      </Card>
    </Container>
  );
}
